document.querySelectorAll('.faq__list').forEach((list) => {
    list.querySelectorAll('.faq__item').forEach((item) => {
        const question = item.querySelector('.faq__question');
        if (!question) return;

        question.addEventListener('click', () => {
            const isOpen = item.classList.contains('is-open');

            list.querySelectorAll('.faq__item.is-open').forEach((openItem) => {
                if (openItem !== item) {
                    openItem.classList.remove('is-open');
                    openItem.querySelector('.faq__question')?.setAttribute('aria-expanded', 'false');
                }
            });

            item.classList.toggle('is-open', !isOpen);
            question.setAttribute('aria-expanded', String(!isOpen));
        });
    });
});
